import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router";
import { helper, http } from "../../util";
import Spin from "../_lib/spin/spin";
import LightBox from "react-awesome-lightbox";
import CustomButton from "../shared/button";
import Ripple from "../shared/Ripple";

import { get } from "../../actions/a.invoice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import Skeleton from "../shared/skeleton";

const InvoiceList = () => {
    const [showLightBox, setShowLightBox] = useState(false);

    const decriptionContainerRef = useRef(null);

    const { arg2 } = useParams();
    const history = useHistory();
    const dispatch = useDispatch();

    const { item, isFetching, imagePath } = useSelector(
        (state) => state.Invoice
    );

    useEffect(() => {
        dispatch(get(arg2));
    }, []);

    useEffect(() => {
        if(Description && decriptionContainerRef.current) {
            decriptionContainerRef.current.innerHTML = item?.Description
        }
    }, [item?.Description])


    if (isFetching || !item)
        return (
            <Skeleton
                align="center"
                schema={skeletonSchema}
                animation="blink"
            />
        );

    const { Image, Title, PayablePrice, Description } = item;


    return (
        <div className="invoice__details">
            <h2> عنوان پیش فاکتور: {Title}</h2>
            <p>مبلغ قابل پرداخت: {helper.toMoney(PayablePrice)} ریال</p>

            <CustomButton
                tabbing="normal"
                className="invoice__formLink"
                func={() => history.push(`/invoice/form/${arg2}`)}
                children={
                    <p>
                        ادامه پرداخت
                        <i className="fa fa-angle-double-left"></i>
                    </p>
                }
                rippleColor="rgba(0,0,0, 0.1)"
            />
            <div
                className="invoice__image"
                onClick={() => setShowLightBox(true)}
            >
                <img
                    onClick={() => setShowLightBox(true)}
                    src={`${process.env.REACT_APP_DOMAIN}${imagePath}${Image}`}
                    alt={Title}
                />
                <i className="fa fa-search"></i>
                <Ripple bubbleColor="rgba(0,0,0, 0.2)" />
            </div>
            {item?.Description && <h4>توضیحات:</h4>}
            <p
                ref={decriptionContainerRef}
                className="invoice__description"
            ></p>
            {showLightBox && (
                <LightBox
                    image={`${process.env.REACT_APP_DOMAIN}${imagePath}${Image}`}
                    title={Title}
                    onClose={() => setShowLightBox(false)}
                    doubleClickZoom={2}
                />
            )}
        </div>
    );
};

const skeletonSchema = [[[97, 30]], [[97, 30]], [[97, 275]]];

export default InvoiceList;
